<template>
  <div class="ym-mk-banner">
    <img class="banner"
         :src="src"
         alt="banner 图"
    >
    <span class="hint"
          v-if="hint !== ''"
    >
      {{ hint }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'YmMKBanner',
    props: {
      src: {
        type: String,
        required: true,
      },
      hint: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-mk-banner {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }

  .banner {
    width: 100%;
    display: block;
  }

  .hint {
    position: absolute;
    left: 0;
    top: @size-large;
    width: 180px;
    height: 60px;
    padding-left: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: 0 30px 30px 0;
    line-height: 1;
    color: @color-text-light;
    font-size: @font-size-base;
    background: #eee;
    box-shadow: 0 8px 8px 0 rgba(51,51,51,0.08);
  }

</style>
